var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.874 1a4.95 4.95 0 0 1 4.294 2.5 5.035 5.035 0 0 1 0 5L15.874 16l-4.293-7.5a5.036 5.036 0 0 1 0-5A4.95 4.95 0 0 1 15.875 1zM1 16c0-1.785.945-3.435 2.479-4.328a4.92 4.92 0 0 1 4.956 0L15.872 16l7.435-4.328a4.922 4.922 0 0 1 4.958 0 5.007 5.007 0 0 1 2.479 4.33 5.007 5.007 0 0 1-2.479 4.33 4.92 4.92 0 0 1-4.958 0l-7.43-4.327 4.29 7.495a5.036 5.036 0 0 1 0 5 4.95 4.95 0 0 1-4.293 2.5 4.95 4.95 0 0 1-4.293-2.5 5.037 5.037 0 0 1 0-5l4.293-7.497-7.437 4.328a4.92 4.92 0 0 1-4.957.001 5.007 5.007 0 0 1-2.48-4.329z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoia);
export default __webpack_public_path__ + "static/media/NOIA.0c5ad01f2d790c3660a54190f327b4d3.svg";
export { ForwardRef as ReactComponent };